import { render, staticRenderFns } from "./select-item-from-api-provided-list.vue?vue&type=template&id=24aa3103&scoped=true&"
import script from "./select-item-from-api-provided-list.vue?vue&type=script&lang=js&"
export * from "./select-item-from-api-provided-list.vue?vue&type=script&lang=js&"
import style0 from "./select-item-from-api-provided-list.vue?vue&type=style&index=0&id=24aa3103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa3103",
  null
  
)

export default component.exports